import type * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Default skeleton fill is `bg-muted-foreground/15`, not `bg-muted`. The
 * dark-mode theme tokens have `--muted: oklch(0.15)` < `--background:
 * oklch(0.17)` — `bg-muted` therefore renders *below* the page surface
 * and disappears for any block larger than a small text run. The muted-
 * foreground gray at 15% opacity reads as a visible lighter rectangle in
 * dark mode and a subtle warm gray in light mode. (`--muted` itself is
 * deliberately a recessed surface for inputs/hovers/banners and stays
 * untouched.)
 */
export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="skeleton"
			className={cn(
				"animate-pulse rounded-md bg-muted-foreground/15 motion-reduce:animate-none",
				className,
			)}
			{...props}
		/>
	);
}
